import * as React from "react";
function SvgImage(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path d="M4 28l7-15 5 8 5-4 7 11H4z" />
      <path
        fill="none"
        strokeMiterlimit={10}
        strokeWidth={2}
        stroke="currentColor"
        d="M1 1h30v30H1z"
      />
      <circle cx={24} cy={8} r={2} />
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgImage);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
